import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore';
import { permissions } from '@utils/permissions';

export const ProtectedRoute = () => {
  const { isAuthenticated, user, loading, checkSession } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    // Redirect to login, preserving intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user status is active
  if (user.status !== 'active') {
    return (
      <div className="status-error-container">
        <div className="status-error-card">
          <h2>Account {user.status}</h2>
          <p>
            Your account status is: <strong>{user.status}</strong>
          </p>
          {user.status === 'pending_approval' && (
            <p>Please wait for an administrator to approve your account.</p>
          )}
          {user.status === 'suspended' && (
            <p>Your account has been suspended. Please contact your administrator.</p>
          )}
          {user.status === 'inactive' && (
            <p>Your account is inactive. Please contact your administrator.</p>
          )}
          <button onClick={() => useAuthStore.getState().logout()} className="btn btn-secondary">
            Logout
          </button>
        </div>
      </div>
    );
  }

  // Check route-level permissions
  if (!permissions.canAccessRoute(user, location.pathname)) {
    return (
      <div className="permission-error-container">
        <div className="permission-error-card">
          <h2>Access Denied</h2>
          <p>You don't have permission to access this page.</p>
          <p>Required permissions may include specific role or system access.</p>
          <button onClick={() => window.history.back()} className="btn btn-secondary">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

